module.exports = __webpack_public_path__ + "img/bottomTab.6c22f3af.svg";